import { render, staticRenderFns } from "./CardLayout.vue?vue&type=template&id=2f852f3c&"
import script from "./CardLayout.vue?vue&type=script&lang=ts&"
export * from "./CardLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports